import { config } from "src/config";

export interface IOrder {
  _id: string,
  buyerId: number,
  sellerId: number,
  statusOrder: string,
  type: string,
  name: string,
  currency: string,
  price: number,
  photo: string,
  description: string,
  requisites: string,
  collateral: number,
  downPayment: number,
  socketId: string
}

interface RequestOrders {
  status: string,
  error: string,
  data: {
    orders: IOrder[] | []
  };
  message: string
}

class OrderService {
  async getUserOrders(id: number): Promise<RequestOrders> {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${config.applicationCode}`);

    const requestOptions: RequestInit = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow" as RequestRedirect
    };

    const url = `${config.p2pAPI}/api/orders/get-user-orders?userId=${id}`;

    try {
      const response = await fetch(url, requestOptions);
      const resultApi = await response.json();

      return resultApi
    } catch (error) {
      return {
        status: 'error',
        error: 'error geting user orders',
        data: {
          orders: []
        },
        message: error.message
      }
    }
  }
}

export default new OrderService;